{
  "version": 1,
  "asset_id": "db1c2763-3fd7-431c-a388-6b194a80b836",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/db1c2763-3fd7-431c-a388-6b194a80b836/sleeve-ugi-reflux-pre-800-es.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/db1c2763-3fd7-431c-a388-6b194a80b836/sleeve-ugi-reflux-pre-800-es.webp",
  "original_filename": "sleeve-ugi-reflux-pre-800-es.webp",
  "size": 40198,
  "content_type": "image/webp",
  "created_at": "2026-09-28T16:44:10Z"
}
